// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import IntegerValue from '../common/IntegerValue';
import { InfoTooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: number;
  className?: string;
  disclaimer?: string;
  item?: ComparisonItem;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const StatCell: React.FunctionComponent<Props> = ({ value, className, item, disclaimer, onClick, id, valueDisclaimer, hasDisclaimer, locale }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  return (
    <div className={classNames(className, 'cell stat-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        <IntegerValue value={value} locale={locale} />

        {hasDisclaimer && '*'}

        {valueDisclaimer && <InfoTooltip title={valueDisclaimer.title} message={valueDisclaimer.message} list={valueDisclaimer.list} />}
      </span>
    </div>
  );
};

export default StatCell;
